(function () {
  function closeTooltip(wrap) {
    if (!wrap) return;
    wrap.classList.remove('is-open');
    const trigger = wrap.querySelector('[data-product-fact-tooltip-trigger]');
    const panel = wrap.querySelector('[data-product-fact-tooltip-panel]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('hidden', '');
  }

  function closeAllTooltipsIn(container) {
    container.querySelectorAll('[data-product-fact-tooltip].is-open').forEach((w) => closeTooltip(w));
  }

  function initContainer(container) {
    if (container.dataset.productFactsInit) return;
    container.dataset.productFactsInit = 'true';

    container.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('[data-product-fact-tooltip-close]');
      if (closeBtn) {
        e.preventDefault();
        closeTooltip(closeBtn.closest('[data-product-fact-tooltip]'));
        return;
      }

      const trigger = e.target.closest('[data-product-fact-tooltip-trigger]');
      if (!trigger || !container.contains(trigger)) return;

      e.preventDefault();
      e.stopPropagation();

      const wrap = trigger.closest('[data-product-fact-tooltip]');
      const panel = wrap && wrap.querySelector('[data-product-fact-tooltip-panel]');
      if (!wrap || !panel) return;

      const wasOpen = wrap.classList.contains('is-open');
      closeAllTooltipsIn(container);

      if (!wasOpen) {
        wrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.removeAttribute('hidden');
      }
    });
  }

  function onDocumentClick(e) {
    if (e.target.closest('[data-product-fact-tooltip]')) return;
    document.querySelectorAll('[data-product-facts] [data-product-fact-tooltip].is-open').forEach((w) => closeTooltip(w));
  }

  function onEscape(e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-product-facts] [data-product-fact-tooltip].is-open').forEach((w) => closeTooltip(w));
  }

  document.addEventListener('click', onDocumentClick);
  document.addEventListener('keydown', onEscape);

  document.querySelectorAll('[data-product-facts]').forEach(initContainer);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-product-facts]').forEach(initContainer);
  });
})();
